<template>
  <div
    class="statement-descriptor-input"
    :class="`${this.checkout ? 'emd-form-group eu-flex-item' : ''}`"
  >
    <label class="emd-label">{{ $t("statement_descriptor.label") }}</label>
    <input
      class="emd-input"
      type="text"
      v-model="statementDescriptor"
      :maxlength="max"
      :disabled="isDisabled()"
      :class="{'_state_error': statementDescriptorFeedbackError}"
      data-testid="input"
    />
    <p data-testid="inputFeedback" class="emd-input-feedback">{{ $t("statement_descriptor.hint") }}</p>
    <p data-testid="inputFeedbackError" class="emd-input-feedback _state_error" v-if=statementDescriptorFeedbackError>{{ $t("statement_descriptor.error.special_characters") }}</p>
  </div>
</template>

<script>
import { containsSpecialCharacters } from '@/utils/validations'
export default {
  name: 'StatementDescriptor',
  data: () => ({
    max: 13,
    statementDescriptor: ''
  }),
  props: {
    acceptCreditCard: Boolean,
    creditCard: Object,
    checkout: Object,
    statementDescriptorFeedbackError: Boolean
  },
  methods: {
    containsSpecialCharacters: containsSpecialCharacters,
    isDisabled () {
      if (this.checkout) {
        return !this.acceptCreditCard
      }
    },
    setStatementDescriptorValue (event) {
      if (this.checkout) {
        this.checkout.credit_card.statement_descriptor = event
      } else {
        this.creditCard.statement_descriptor = event
      }
    },
    setStatementDescriptorPaymentType () {
      if (this.checkout) {
        return this.checkout.credit_card.statement_descriptor
      } else {
        return this.creditCard.statement_descriptor
      }
    },
    showFeedbackError () {
      if (this.containsSpecialCharacters(this.statementDescriptor)) {
        this.$emit('setStatementDescriptorFeedbackError', true)
      } else {
        this.$emit('setStatementDescriptorFeedbackError', false)
      }
    }
  },
  watch: {
    statementDescriptor: {
      handler: function () {
        this.showFeedbackError()
        this.setStatementDescriptorValue(this.statementDescriptor)
      }
    }
  },
  beforeMount () {
    this.statementDescriptor = this.setStatementDescriptorPaymentType()
  }
}
</script>

<style scoped>
.statement-descriptor-input {
  max-width: 18.375rem;
}
</style>
